// extracted by mini-css-extract-plugin
export var button = "_dn-4";
export var hasDarkBackground = "_dn-7";
export var hasLightBackground = "_dn-6";
export var iconWrapper = "_dn-0";
export var large = "_dn-2";
export var medium = "_dn-1";
export var small = "_dn-5";
export var xsmall = "_dn-3";